import React,{useState,useRef} from 'react'
import syllabus from "./assets/ecesyllabus.pdf"
// import {Link, BrowserRouter, Route, Routes} from "react-router-dom";
// import Ob from './cse4sub/Ob.js';
import ec1 from "./assets/ash1.pdf"
import ec2 from "./assets/ash2.pdf"
import ec3 from "./assets/ece3.pdf"
import ec4 from "./assets/ece4.pdf"
import ec5 from "./assets/ece5.pdf"
import ec6 from "./assets/ece6.pdf"
import ec7 from "./assets/ece7.pdf"
import ec8 from "./assets/ece8.pdf"
import Dept from './Dept';

import eceimg from "./eceimg.jpg"
// import AE from './AE';
export default function ECE() {
  
  const [sem, setSem] = useState([{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}
    ,{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}]);
  
    const ref = useRef(null);

  const handleClick = () => {
    ref.current.scrollIntoView({behavior: 'smooth'});
  };
  
  function contentOfElectivePapers(){
    let paper=[
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub: 'professionals & Open Elective courses:'},
      {sub:'List of Professionals Elective Courses(PE):'},
       {sub:'CMOS Design'},{sub:'Power Electronics'},{sub:'Nano Electronics'},
       {sub:'Mixed Signal design'},
      {sub: 'High Speed Electronics'},{sub:'Mobile Communication & Networks'},
       {sub:'Fiber Optic Communication'},{sub:'Satellite Communication'},
       {sub:'Wireless Sensors Networks(WSN)'},{sub:'Wavelets'},
       {sub:'Information Theory and Coding '},{sub:'Speech and Audio Processing'},
       {sub:'Digital Image & Video Processing'},{sub:'Adaptive Signal Processing'},
       {sub:'Microwave Theory and Techniques'},{sub:'Introduction to MEMS'},
       {sub:'Scientific Computing'},{sub:'Embedded Systems'},
       {sub:'Error Correcting Codes'},{sub:''},
       {sub:'List of Open Elective Courses(OE):'},
       {sub:'Values and Ethics'},
       {sub:'Understanding Culture and Society through Literature'},
       {sub:'History of Science and Technology in India'},{sub:'Operating System'},
       {sub:'Biomedical Instrumentation'},{sub:'Advanced Digital System Design'},
       {sub:'Analog VLSI Design'},{sub:''},
       {sub:''},{sub:''},
       { sub:"---", link:" "}//43rd
    ];
    setSem(paper);
  }
  function contentOfSem1(){
    let content=[
      {title: "Subjects:",sub:"Engineering Physics(ASH101)", link:"/CSE/Ep"},
      {sub:"Mathematics-1(ASH102)", link:"CSE/M_1"},
      {sub:"Preparatory English(ASH103)", link:"CSE/Peng"},
      {sub:"Engineering Physics Lab(ASH104)", link:"CSE/EpLab"},
      {sub:"Workshop/Manufacturing Practices(ASH105)", link:"CSE/Wpm"},
      {sub:"Engineering Graphics & Design(ASH106)", link:"CSE/Egd"},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
       {sub:""},{sub:""},{sub:"1st Semester",link:ec1}//43rd
      
    ];
    setSem(content);
  }
  function contentOfSem2(){
    let content=[
      {title: "Subjects:",sub:"Engineering Chemistry(ASH201)", link:"/CSE/Ec"},
      {sub:"Mathematics-2(ASH202)", link:"CSE/M_2"},
      {sub:"Programming for problem Solving(ASH203)", link:"CSE/Pfps"},
      {sub:"Basic Electrical Engineering(ASH204)", link:"CSE/Bee"},
      {sub:"English-2(ASH205)", link:"CSE/Eng_2"},
      {sub:"Engineering Chemistry Lab(ASH206)", link:"CSE/EcLab"},
      {sub:"Programming for Problem Solving Lab(ASH207)", link:"CSE/CLab"},
      {sub:"Basic Electrical Engineering Lab(ASH208)", link:"CSE/BeeLab"},{sub:"", link:""},{sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"2nd Semester",link:ec2}
    ];
    setSem(content);
  }
  function contentOfSem3(){
    let content=[
      {title: "Subjects:",sub:"Electronic Devices(ECE301)", link:"/ECE/Ed"},
      {sub:"Electronic Devices Lab(ECE302)", link:"ECE/EdLab"},
      {sub:"Digital System Design(ECE303)", link:"ECE/Dsd"},
      {sub:"Digital System Design Lab(ECE304)", link:"ECE/DsdLab"},
      {sub:"Signal & Systems(ECE305)", link:"ECE/Ss"},
      {sub:"Network Theory(ECE306)", link:"ECE/Nt"},
      {sub:"Network Theory Lab(ECE307)", link:"ECE/NtLab"},
      {sub:"Mathematics-3(ASH301A)", link:"/ECE/Ma_3"},
      {sub:"Effective Technical Communication(ASH302)", link:"CSE/Etc"},
      {sub:"Basic Electronics(ASH305)", link:"ECE/Be"},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"3rd Semester",link:ec3}
    ];
    setSem(content);
  }
  function contentOfSem4(){
    let content=[
       {title: "Subjects:", sub: "Analog & Digital Communication(ECE401)",link: "/ECE/Adc"},
       {sub:"Analog & Digital Communication Lab(ECE402)", link:"ECE/AdcLab" },
        {sub: "Analog Electronic Circuit(ECE403)", link:"ECE/Aece"},
        {sub:"Analog Electronic Circuit Lab(ECE404)", link:"ECE/AeceLab"},
        {sub:"Microprocessor & Microcontroller(ECE405)", link:"/ECE/Mm"},
        {sub:"Microprocessor & Microcontroller Lab(ECE406)",link:"ECE/MmLab"},
        {sub:"Microelectronics Technology(ECE407)", link:"ECE/Mt"},
        {sub:"Energy Science & Engineering(ECE408)", link:"ECE/Ese"},
        {sub: "Organizational Behavior(ASH401)",link: "/CSE/Ob"},
        {sub:"Environmental Science(ASH402)", link:" CSE/Evs" },
        {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"4th Semester",link:ec4}
    ];
       setSem(content);
  }
  function contentOfSem5(){
    let content=[
      {title: "Subjects:",sub:"Electromagnetic Wave(ECE501)", link:"/ECE/Emw"},
      {sub:"Electromagnetic Wave Lab(ECE502)", link:"ECE/EmwLab"},
      {sub:"Computer Architecture(ECE503)", link:"ECE/Ca"},
      {sub:"Probability Theory and Stochastic Process(ECE504)", link:"ECE/Ptsp"},
      {sub:"DSP(ECE505)", link:"ECE/Dsp"},
      {sub:"DSP Lab(ECE506)", link:"ECE/DspLab"},
      {sub:"Operations Research & Industrial Management(ASH502)", link:"ECE/Orim"},
      {sub:"Constitution of India(ASH503)", link:"CSE/Coi"},
      {sub:"", link:""},{sub:"", link:""},
      {sub:"Remaining are elective papers"},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"5th Semester",link:ec5}
    ];
    setSem(content);
  }
  function contentOfSem6(){
    let content=[
      {title: "Subjects:",sub:"Control System(ECE601)", link:"/ECE/Cs"},
      {sub:"Computer Networks(ECE602)", link:"ECE/Cnk"},
      {sub:"Computer Networks Lab(ECE603)", link:"ECE/CnkLab"},
      {sub:"Electronic Instrumentation and Measurement(ECE605)", link:"ECE/Eim"},
      {sub:"Understanding Culture & Society through Literature(ASH601)", link:"ECE/Ucs"},
      {sub:"", link:""},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"Remaining are elective papers"},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"6th Semester",link:ec6}
    ];
    setSem(content);
  }
  function contentOfSem7(){
    let content=[
      {title: "Subjects:",sub:"Antenas & Wave Propagation(ECE706)", link:"/ECE/Awp"},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"Remaining are elective papers"},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:"7th Semester",link:ec7}
    ];
    setSem(content);
   }
   function contentOfSem8(){
    let content=[
      {title: "Subjects:",sub:"", link:""},
      {sub:"", link:""},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"Only elective papers & projects are in this semester"},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:"8th Semester",link:ec8}
    ];
    setSem(content);
  }
    return (
      <>
      <Dept title="Dept. of Electronics & Communication Engineering" dept="ECE" syllabus={syllabus} img={eceimg} />
      <div className='container my-3'>
            <h5 className='text-center'>Select your semester to see the corresponding content:</h5>
             <div className="btn-toolbar justify-content-center" role="toolbar" aria-label="Toolbar with button groups">
                <div className="btn-group btn-group-sm" role="group" aria-label="Small group">
               
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem1();handleClick();}}>1st sem</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem2();handleClick();}}>2nd</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem3();handleClick();}}>3rd</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem4();handleClick();}}>4th</button>
                
                  <button type="button" className="btn btn-secondary"onClick={()=>{contentOfSem5();handleClick();}}>5th</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem6();handleClick();}}>6th</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem7();handleClick();}}>7th</button>
                  <button type="button" className="btn btn-secondary" onClick={() => {contentOfSem8();handleClick();}}>8th</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfElectivePapers();handleClick();}}>Elective Papers</button>
                </div>
             </div>
      </div>
         <div className='container my-4 '>
         <div className='container my-4 text-center'  >
            
            <div className="col d-flex justify-content-center my-4">
              <div className="card my-3"  style= {{width: "20rem"}}>
                  
                  <div className="card-body">
                      <h5 className="card-title">Course Structure/Syllabus of <b>{sem[43].sub}</b> </h5>
                      <a href={sem[43].link} className="btn btn-primary" target="blank">Preview/Download</a>
                  </div>  
              </div>
            </div>
        </div>
         <h2 className='mx-5'>{sem[0].title}</h2>       
           <h5 className='mx-5' ref={ref}>
            <div className='my-2'> <a href={sem[0].link}>{sem[0].sub}</a></div>
            <div className='my-2'> <a href={sem[1].link}>{sem[1].sub}</a></div>
            <div className='my-2'><a href={sem[2].link}>{sem[2].sub}</a></div>
            <div className='my-2'><a href={sem[3].link}>{sem[3].sub}</a></div>
            <div className='my-2'><a href={sem[4].link}>{sem[4].sub}</a></div> 
            <div className='my-2'><a href={sem[5].link}>{sem[5].sub}</a></div>
            <div className='my-2'><a href={sem[6].link}>{sem[6].sub}</a></div>
            <div className='my-2'><a href={sem[7].link}>{sem[7].sub}</a></div>
            <div className='my-2'> <a href={sem[8].link}>{sem[8].sub}</a></div>
            <div className='my-2'> <a href={sem[9].link}>{sem[9].sub}</a></div>
           </h5>
           <h3 className='mx-5'>{sem[10].sub}</h3>
           <h5  className='mx-5' ref={ref}>
             <div><h4>{sem[11].sub}</h4></div> <div>{sem[12].sub}</div>
            <div>{sem[13].sub}</div> <div>{sem[14].sub}</div> <div>{sem[15].sub}</div> <div>{sem[16].sub}</div>
            <div>{sem[17].sub}</div> <div>{sem[18].sub}</div> <div>{sem[19].sub}</div> <div>{sem[20].sub}</div>
            <div>{sem[21].sub}</div> <div>{sem[22].sub}</div> <div>{sem[23].sub}</div> <div>{sem[24].sub}</div>
            <div>{sem[25].sub}</div> <div>{sem[26].sub}</div> <div>{sem[27].sub}</div> <div>{sem[28].sub}</div>
            <div>{sem[29].sub}</div> <div>{sem[30].sub}</div> <div>{sem[31].sub}</div> <div> <h4>{sem[32].sub}</h4></div>
            <div>{sem[33].sub}</div> <div>{sem[34].sub}</div> <div>{sem[35].sub}</div> <div>{sem[36].sub}</div>
            <div>{sem[37].sub}</div> <div>{sem[38].sub}</div> <div>{sem[39].sub}</div> <div>{sem[40].sub}</div>
            <div>{sem[41].sub}</div> 
           </h5>
          {/* <h4 className='mx-5'><a href={sem[42].link}>{sem[42].sub}</a> </h4> */}
         </div>
      
    </>
  );
}
